const LoadingIndicator = ({ fullPage = true }: { fullPage?: boolean }) => {
  const wrapperClassName = fullPage
    ? "fixed top-1/2 left-1/2 z-20 translate-x-[-50%] translate-y-[-50%]"
    : null;
  return (
    <div className={wrapperClassName || undefined}>
      <div className="border-accent-content py-2 px-3">
        <div className="loading-spinner">
          <div className="spinner">
            <div />
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoadingIndicator;
